import errorCodes from "../../generated/smartContractHelpers/errorCodes.json"

export type ErrorCodeName = keyof typeof errorCodes

export function errorCodesFromName(...names: ErrorCodeName[]): number[] {
  return names.flatMap(name => errorCodes[name].map(a => a.code))
}
